import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertNotificationService } from '../../../../../services/alert-notification.service';
import { FormService } from '../../../../../services/form.service';
import { ValidatorService } from '../../../../../services/validator.service';
import { InputFieldComponent } from '../../../../../components/form/input-field/input-field.component';
import { Location } from '@angular/common';
import { AlertInfo } from 'src/app/models/alert-info';
import { SavedDataInfo } from 'src/app/models/form/saved-data-info';
import { NgbAlert } from '@ng-bootstrap/ng-bootstrap';
import { SpecialisationsService } from 'src/app/services/api/hr/specialisations.service';

@Component({
  selector: 'specialisation-form',
  imports: [ReactiveFormsModule, InputFieldComponent, NgbAlert],
  templateUrl: './specialisation-form.component.html',
  styleUrl: './specialisation-form.component.scss',
})
export class SpecialisationFormComponent {
   @Input() employeeSpecialisation?: any;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();

  form!: FormGroup;

  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  constructor(
    private validatorService: ValidatorService,
    private formService: FormService,
    private alertNotificationService: AlertNotificationService,
    private specialisationsService: SpecialisationsService,
    private location: Location,
  ) { }


  ngOnInit(): void {
    this.form = new FormGroup({
      code: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['employeeSpecialisation'] && changes['employeeSpecialisation'].currentValue) {
      this.form.patchValue({
        code: this.employeeSpecialisation.code,
        name: this.employeeSpecialisation.name,
      });
    }
  }

  /**
   * *******************
   * Submit form methods
   * *******************
   */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.form);
    this.formService.setValidationErrors(this.form, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  submitForm(): void {

    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      control?.markAsTouched();
      control?.updateValueAndValidity();
    });

    if (this.form.valid) {

      const values = Object.assign(
        this.form.value,
        {
          tenantId: 1,
        },
      )

      this.alertInfo.show = false;
      this.formService.resetErrors(this.form);

      const serviceMethod = this.employeeSpecialisation ? this.specialisationsService.update(this.employeeSpecialisation.employeeSpecialisationId, values) : this.specialisationsService.create(values);
      serviceMethod.subscribe({
        next: (response: any) => {
          this.submitFormSuccess(response)
        },
        error: (error: any) => {
          this.submitFormError(error)
        }
      })
    }
  }

  goBack(): void {
    this.location.back();

  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */



  getSpecialisationCodeInput(): FormControl { return this.getFormControl('code'); }
  getSpecialisationNameInput(): FormControl { return this.getFormControl('name'); }
  getFormControl(name: string): FormControl { return this.form.get(name) as FormControl; }
}